import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const ConversionBannerCCD: IClientComponentDefinition = {
  name: 'conversionBanner',
  load: () => import(/* webpackChunkName: 'conversionBanner' */ './index'),
}
